/**
 * 该图片组件基于 next/legacy/image，是next.js 13之前的组件，其默认的懒加载方式在老版本的机器上兼容性不好，还是用新的吧
 */
import { useState, useCallback, useEffect } from 'react';
import Image, { ImageProps } from 'next/legacy/image';

type MImageProps = ImageProps & {
  // 图片加载错误时兜底图
  errorImg?: string;
  // 是否动图，当为动图时，不能使用cdn loader
  isAni?: boolean;
  // 是否使用cdn转化为 webp
  formatWebp?: boolean;
};

export const MImage: (props: MImageProps) => React.ReactElement<any> = (props) => {
  const {
    src = '',
    errorImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNs2AQAAbgBNMqymOwAAAAASUVORK5CYII=',
    isAni,
    formatWebp,
    ...rest
  } = props;
  const [imgSrc, setImgSrc] = useState(src);
  const qiniuLoader = useCallback(
    ({ src, width, quality }) => {
      if (isAni) {
        return src;
      }
      let url = `${src}?imageView2/2/w/${width}/q/${quality || 75}`;
      if (formatWebp) {
        url += '/format/webp';
      }
      return url;
    },
    [formatWebp, isAni]
  );
  const handleError = useCallback(() => setImgSrc(errorImg), [errorImg]);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return <Image {...rest} src={imgSrc} loader={qiniuLoader} onError={handleError} />;
};
export default MImage;
